<template>
  <div class="app" v-title data-title="富林印迹-广富林文化遗址公园">
    <component :is="headerComponent" :activeIndex="2" />
    <div class="yj-banner rel">
      <img src="@/assets/images/wz-banner.png" class="db wp100" alt="banner">
      <div class="crumbs-nav df align_center justify_end fa_wh box-border">
        <router-link to="/" class="f16 fw">首页</router-link>
        <img src="@/assets/images/arrow-wh-05.png" class="db w20 ml5 mr5" alt="">
        <router-link to="/pages/wanzhuan/index" class="f16 fw">玩转富林</router-link>
      </div>
      <div class="yj-banner-tit df align_center flex_column justify_center ts fw">
        <div class="f50 ls1 b">玩转富林</div>
        <div class="f17 ls3">Explore Guangfulin</div>
      </div>
    </div>
    <div class="spot-cont mt-60 pb100">
      <div class="wz-yanyi-box pt20 pb50" v-if="whyzData">
        <div class="spot-tit spot-view-tit df align_center justify_center">
          <h2 class="f32 foo pb50">{{ whyzData.Name }}</h2>
        </div>
        <div class="spot-intro f16 tc mt5 w1000 auto" v-if="whyzData.Items && whyzData.Items.length > 0">
          {{ whyzData.Items[0].ContentText | clearHtml(1000) }}
        </div>
        <div class="wz-yanyi-swp w1000 auto mt50" v-if="whyzData.Items && whyzData.Items.length > 0">
          <el-carousel height="467px">
            <el-carousel-item v-for="picItem in whyzData.Items" :key="picItem.Id">
              <img :src="picItem.Photo + '!/both/2000x1000'" class="db wp100" alt="" />
            </el-carousel-item>
          </el-carousel>
        </div>
      </div>

      <div class="wz-yanyi-box pt20 pb50" v-if="flxjData">
        <div class="spot-tit spot-view-tit df align_center justify_center">
          <h2 class="f32 foo pb50">{{ flxjData.Name }}</h2>
        </div>
        <div class="spot-intro f16 tc mt5 w1000 auto" v-if="flxjData.Items && flxjData.Items.length > 0">
          {{ flxjData.Items[0].ContentText | clearHtml(1000) }}
        </div>
        <div class="wz-yanyi-swp w1000 auto mt50" v-if="flxjData.Items && flxjData.Items.length > 0">
          <el-carousel height="467px">
            <el-carousel-item v-for="picItem in flxjData.Items" :key="picItem.Id">
              <img :src="picItem.Photo + '!/both/2000x1000'" class="db wp100" alt="" />
            </el-carousel-item>
          </el-carousel>
        </div>
      </div>

      <div class="wz-yanyi-box pt20 pb50" v-if="jqygData">
        <div class="spot-tit spot-view-tit df align_center justify_center">
          <h2 class="f32 foo pb50">{{ jqygData.Name }}</h2>
        </div>
        <div class="spot-intro f16 tc mt5 w1000 auto" v-if="jqygData.Items && jqygData.Items.length > 0">
          {{ jqygData.Items[0].ContentText | clearHtml(1000) }}
        </div>
        <div class="wz-yanyi-swp w1000 auto mt50" v-if="jqygData.Items && jqygData.Items.length > 0">
          <el-carousel height="467px">
            <el-carousel-item v-for="picItem in jqygData.Items" :key="picItem.Id">
              <img :src="picItem.Photo + '!/both/2000x1000'" class="db wp100" alt="" />
            </el-carousel-item>
          </el-carousel>
        </div>
      </div>

      <div class="wz-yanyi-box pt20 pb50" v-if="flzxData">
        <div class="spot-tit spot-view-tit df align_center justify_center">
          <h2 class="f32 foo pb50">{{ flzxData.Name }}</h2>
        </div>
        <div class="spot-intro f16 tc mt5 w1000 auto" v-if="flzxData.Items && flzxData.Items.length > 0">
          {{ flzxData.Items[0].ContentText | clearHtml(1000) }}
        </div>
        <div class="wz-yanyi-swp w1000 auto mt50" v-if="flzxData.Items && flzxData.Items.length > 0">
          <el-carousel height="467px">
            <el-carousel-item v-for="picItem in flzxData.Items" :key="picItem.Id">
              <img :src="picItem.Photo + '!/both/2000x1000'" class="db wp100" alt="" />
            </el-carousel-item>
          </el-carousel>
        </div>
      </div>

      <div class="wz-yanyi-box pt20 pb50" v-if="fcxmData">
        <div class="spot-tit spot-view-tit df align_center justify_center">
          <h2 class="f32 foo pb50">{{ fcxmData.Name }}</h2>
        </div>
        <div class="spot-intro f16 tc mt5 w1000 auto" v-if="fcxmData.Items && fcxmData.Items.length > 0">
          {{ fcxmData.Items[0].ContentText | clearHtml(1000) }}
        </div>
        <div class="wz-yanyi-swp w1000 auto mt50" v-if="fcxmData.Items && fcxmData.Items.length > 0">
          <el-carousel height="467px">
            <el-carousel-item v-for="picItem in fcxmData.Items" :key="picItem.Id">
              <img :src="picItem.Photo + '!/both/2000x1000'" class="db wp100" alt="" />
            </el-carousel-item>
          </el-carousel>
        </div>
      </div>
      <!-- <div class="wz-yanyi-box pt20 pb50">
        <div class="spot-tit spot-view-tit df align_center justify_center">
          <h2 class="f32 foo pb50">广富林文化遗址</h2>
        </div>
        <div class="spot-intro f16 tc mt5 w1000 auto">文化遗存，记载着人类的文明和进步，见证着城市的兴起和发展，无论是断壁残垣，或是深埋水土，它的存在，永远是这座城市走向未来的精神家园。</div>
        <div class="wz-yanyi-swp w1000 auto mt50">
          <el-carousel height="467px">
            <el-carousel-item v-for="item in 4" :key="item">
              <img src="@/assets/images/spot-view-p1.png" class="db wp100" alt="" />
            </el-carousel-item>
          </el-carousel>
        </div>
      </div>
      <div class="wz-yanyi-box pt20 pb50">
        <div class="spot-tit spot-view-tit df align_center justify_center">
          <h2 class="f32 foo pb50">富林雪景</h2>
        </div>
        <div class="spot-intro f16 tc mt5 w1000 auto">
          洋洋洒洒的大雪，为广富林裹上了一层银装，静谧端庄，楚楚动人
        </div>
        <div class="wz-yanyi-swp w1000 auto mt50">
          <el-carousel height="467px">
            <el-carousel-item v-for="item in 4" :key="item">
              <img src="@/assets/images/spot-view-p1.png" class="db wp100" alt="" />
            </el-carousel-item>
          </el-carousel>
        </div>
      </div>
      <div class="wz-yanyi-box pt20 pb50">
        <div class="spot-tit spot-view-tit df align_center justify_center">
          <h2 class="f32 foo pb50">金秋阳光温馨恬静</h2>
        </div>
        <div class="spot-intro f16 tc mt5 w1000 auto">
          金秋的阳光温馨恬静，金秋的微风和煦轻柔，金秋的蓝天白云飘逸，金秋的田野遍地金黄。 身披绿色长发的垂柳，今日已变得枯黄干燥，伴着凉爽的秋风，一片片落叶纷纷飘下。
        </div>
        <div class="wz-yanyi-swp w1000 auto mt50">
          <el-carousel height="467px">
            <el-carousel-item v-for="item in 4" :key="item">
              <img src="@/assets/images/spot-view-p1.png" class="db wp100" alt="" />
            </el-carousel-item>
          </el-carousel>
        </div>
      </div>
      <div class="wz-yanyi-box pt20 pb50">
        <div class="spot-tit spot-view-tit df align_center justify_center">
          <h2 class="f32 foo pb50">富林之夏</h2>
        </div>
        <div class="spot-intro f16 tc mt5 w1000 auto">
          夏日的晴空是灿烂的，天是那样的蓝，日光是那样的强烈，天上地下处于一片耀眼的光明之中。
        </div>
        <div class="wz-yanyi-swp w1000 auto mt50">
          <el-carousel height="467px">
            <el-carousel-item v-for="item in 4" :key="item">
              <img src="@/assets/images/spot-view-p1.png" class="db wp100" alt="" />
            </el-carousel-item>
          </el-carousel>
        </div>
      </div>
      <div class="wz-yanyi-box pt20 pb50">
        <div class="spot-tit spot-view-tit df align_center justify_center">
          <h2 class="f32 foo pb50">芳草鲜美，落英缤纷</h2>
        </div>
        <div class="spot-intro f16 tc mt5 w1000 auto">
          “芳草鲜美，落英缤纷”，沿着皇甫路，樱花遍撒满地，透露着春的气息。
        </div>
        <div class="wz-yanyi-swp w1000 auto mt50">
          <el-carousel height="467px">
            <el-carousel-item v-for="item in 4" :key="item">
              <img src="@/assets/images/spot-view-p1.png" class="db wp100" alt="" />
            </el-carousel-item>
          </el-carousel>
        </div>
      </div> -->
    </div>
    <component :is="bottomComponent" />
  </div>
</template>

<script>
import Header from '../../components/header.vue'
import Bottom from '../../components/bottom.vue'
import promotionService from '@/services/client/cont/promotion'

export default {
  name: 'app',
  data () {
    return {
      headerComponent: 'Header',
      bottomComponent: 'Bottom',
      code: [
        'app-wzfl-jcyy-gflwhyz',
        'app-wzfl-jcyy-flxj',
        'app-wzfl-jcyy-jqygwxtj',
        'app-wzfl-jcyy-flzx',
        'app-wzfl-jcyy-fcxmlybf',
      ],
      whyzData: null,
      flxjData: null,
      jqygData: null,
      flzxData: null,
      fcxmData: null,
    }
  },
  components: { Header, Bottom,},
  mounted(){
    this.initData();
  },
  methods:{
    initData() {
      this.loadWhyzData();
      this.loadFlxjData();
      this.loadJqygData();
      this.loadFlzxData();
      this.loadFcxmData();
    },
    loadWhyzData() {
      promotionService.detail(this.code[0]).then(res => {
        if(res.Code == 200) {
          this.whyzData = res.Data;
        }
      });
    },
    loadFlxjData() {
      promotionService.detail(this.code[1]).then(res => {
        if(res.Code == 200) {
          this.flxjData = res.Data;
        }
      });
    },
    loadJqygData() {
      promotionService.detail(this.code[2]).then(res => {
        if(res.Code == 200) {
          this.jqygData = res.Data;
        }
      });
    },
    loadFlzxData() {
      promotionService.detail(this.code[3]).then(res => {
        if(res.Code == 200) {
          this.flzxData = res.Data;
        }
      });
    },
    loadFcxmData() {
      promotionService.detail(this.code[4]).then(res => {
        if(res.Code == 200) {
          this.fcxmData = res.Data;
        }
      });
    },
  },

}
</script>



// WEBPACK FOOTER //
// src/views/wanzhuan/yanyi.vue